import { useEffect } from "react"

export default function Admindashboard() {

    useEffect(() => {
        window.location.href = "https://admin.atxfloods.com"
    }, [])

    return null
}